// extracted by mini-css-extract-plugin
export default {"searchcontainer":"SearchBox_searchcontainer__wQoR7"};